import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ComponentsModule } from '../components/components.module';

@NgModule({
    imports: [
        IonicModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ComponentsModule,
    ],
    declarations: [
        // ModalDetalheGraficoComponent,

    ],
    exports: [
        // ModalDetalheGraficoComponent,


    ],
})

export class ModalComponentsModule {
}
